import styled from 'styled-components';

const SearchCustomerInputWrapper = styled.div`
    flex: 1;
`;

export default SearchCustomerInputWrapper;
